<script lang="ts">
  // show listBox from array
  // dispatch selected message with selected item and index of selected item
  // for single selection only

  import { onDestroy } from "svelte";

  // PROPS ---------------------------------------------------

  let {
    items = $bindable([]),
    selectedItem = $bindable(""),
    selectedIndex = $bindable(null),
    pre = false,
    grayed = false,
    largefont = false,
  } = $props();

  // COMPONENT LIFECYCLE -----------------------------------------

  onDestroy(() => {
    // clear array --- may not be necessary for garbage collection ???
    items = null;
  });

  // FUNCTIONS ---------------------------------------------------

  const listItemClicked = (index: number): void => {
    if (selectedIndex === index) {
      selectedIndex = null;
      selectedItem = "";
    } else {
      selectedIndex = index;
      selectedItem = items![index];
    }
  };
</script>

<!-- HTML ===================================================== -->

<!-- <div class="page"> -->
<div class="listbox" class:grayed class:largefont>
  {#each items as item, index}
    <div
      class:selected={selectedIndex === index}
      class="listitem"
      onclick={() => listItemClicked(index)}
    >
      {#if pre}
        <pre>{item}</pre>
      {:else}
        {item}
      {/if}
    </div>
  {/each}
</div>

<!-- </div> -->

<!-- CSS ===================================================== -->
<style>
  pre {
    font-family: "Courier New", Courier, monospace;
  }
  .listbox {
    border: rgb(55, 52, 103) solid;
    line-height: 1.2em;
    padding: 0 1% 0 1%;
    height: 100%;
    overflow: scroll;
  }
  .largefont {
    font-size: 1.2em;
    line-height: 1.4;
  }
  .selected {
    color: white;
    background: var(--key-hover-border-color);
  }
  .grayed {
    border: gray solid;
  }
  .listitem {
    cursor: pointer;
  }
</style>
